<div class="login-body">
    <p-toast position="top-center">
    </p-toast>
    <div class="login-panel">
      <div class="flex-col">
        <div>
          <img src="assets/layout/images/logo-login.png" />
          <h1>Passwort vergessen</h1>
          <h2>{{app.appName}}</h2>
        </div>
        <p-message *ngIf="errorMessage != null" severity="danger" [text]="errorMessage" [escape]=false></p-message>
        <sm-form *ngIf="errorMessage == null" [form]="form">
        </sm-form>
        <div>
          <p-button *ngIf="errorMessage == null" styleClass="width100p" icon="fas fa-sign-in" [label]="userName == null ? 'Weiter' : 'Abschließen'" (onClick)="send()">
          </p-button>
         
          <div *ngIf="running">
            <div>Rücksetzung läuft ...</div>
            <p-progressSpinner></p-progressSpinner>

        </div>
      </div>
    </div>
  </div>
